module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-right-bb55e42ed946db157605e8028b41bf3b.svg";